import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=3504e35e&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editor.vue?vue&type=style&index=1&id=3504e35e&scoped=true&lang=css&"
import style2 from "./editor.vue?vue&type=style&index=2&id=3504e35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3504e35e",
  null
  
)

export default component.exports